/* Kesha Speaks wordmark — uses the uploaded asset. Contained, not cropped. */
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_clarity-check-40/artifacts/uljdbwzj_kesha%20speaks%20logo_no%20face_drk%20bg.png";

export default function KeshaMark({ className = "h-8 w-auto" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Kesha Speaks"
      className={`${className} object-contain`}
      draggable="false"
    />
  );
}

export { LOGO_URL };
